import React from 'react';
import {PdfLinkButton} from './PdfLinkButton';

/**
 * Renders a button group
 */
export const ButtonGroup = ({buttons, data, styleSheet, settings, filterState}) => {
  return (buttons && buttons.length > 0 &&
    <div className={'table-buttons p-0'}>
      {buttons.map((button, key) => {
        switch (button.type) {
          case 'pdfLink':
            return (
              <PdfLinkButton
                key={button.id}
                button={button}
                data={data}
                styleSheet={styleSheet}
                settings={settings}
                filterState={filterState}
              />
            );
          default:
            return null;
        }
      })}
    </div>
  );
};